// material-ui
import Box from '@mui/material/Box';

// project imports
import useConfig from 'hooks/useConfig';
import { ThemeMode } from 'config';

// assets
import logoShort from 'assets/images/logo-light-short.png';

// ==============================|| LOGO ICON ||============================== //

export default function LogoIcon() {
  const { mode } = useConfig();
  const isDarkMode = mode === ThemeMode.DARK;

  return (
    <Box
      component="img"
      src={logoShort}
      alt="AYRO Logo"
      sx={{
        height: 32,
        width: 'auto',
        objectFit: 'contain',
        // In dark mode, apply filter to make logo whitish for better visibility
        filter: isDarkMode ? 'brightness(0) invert(1) brightness(0.9)' : 'none'
      }}
    />
  );
}
